var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27153 7.90262C6.12144 8.03246 5.87895 8.03246 5.72847 7.90262L2.16286 4.82096C1.94571 4.63351 1.94571 4.32854 2.16286 4.14077C2.38001 3.95332 2.73244 3.95332 2.94959 4.14077L6.00019 6.77696L9.05002 4.14077C9.26756 3.95332 9.61999 3.95332 9.83714 4.14077C10.0543 4.32854 10.0543 4.63351 9.83714 4.82095L6.27153 7.90262Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/Arrow (1).3c768f7586a6e1e106ab267629e98180.svg";
export { ForwardRef as ReactComponent };